import {
  apiClient,
  type SiteExEntity,
  type UpdateSiteSiteGroupCodeDto
} from '@/libs/api'

export type UpdateSiteSiteGroupCodeRequest = {
  tenantKey: string
  siteId: number
  dto: UpdateSiteSiteGroupCodeDto
}

/**
 * VOC_PJ-630 #3669: 地点セレクトの候補行から、選択中の荷主と地点をその場で
 * 関連付ける際に地点側の関連地点関連付けコードを更新する。
 */
export const updateSiteSiteGroupCode = async ({
  tenantKey,
  siteId,
  dto
}: UpdateSiteSiteGroupCodeRequest): Promise<SiteExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .sites._id(siteId)
    .site_group_code.$put({ body: dto })
  return data
}
